(function () {
  'use strict';

  if (window._ddMiniCartInit) return;
  window._ddMiniCartInit = true;

  var helpers = window.ddCartHelpers;
  if (!helpers) {
    console.warn('[dd-mini-cart] dd-cart-helpers.js not loaded');
    return;
  }

  var DRAWER_SEL = '#CartDrawer';
  var ITEMS_SEL = '[data-dd-cart-items]';
  var COUNT_SEL = '[data-dd-drawer-count]';
  var THRESHOLD_SEL = '[data-dd-threshold]';
  var THRESHOLD_TEXT_SEL = '[data-dd-threshold-text]';
  var EMPTY_SEL = '[data-dd-cart-empty]';
  var CONTENT_SEL = '[data-dd-cart-content]';
  var CHECKOUT_BTN_SEL = '[data-dd-checkout]';
  var PROT_CONSENT_SEL = '[data-shipping-protection-consent]';
  var PROT_WIDGET_SEL = '[data-dd-protection]';
  var PROT_TOGGLE_SEL = '[data-dd-protection-toggle]';
  var PROT_TOAST_SEL = '[data-dd-protection-toast]';
  var CHECKOUT_URL = '/checkout';
  var PROT_COUNTDOWN_MS = 5000;
  var CHECKOUT_WARN_TTL = 6000;
  var THRESHOLD_GRACE_MS = 650;
  var THRESHOLD_EXIT_MS = 360;
  var THRESHOLD_TEXT_SWAP_MS = 180;

  var _prevThresholdMet = false;
  var _thresholdInitialized = false;
  var _thresholdGraceTimer = null;
  var _thresholdExitTimer = null;
  var _thresholdTextTimer = null;
  var _isSavingNote = false;
  var _savingNoteTimeout = null;
  var NOTE_SAFETY_TIMEOUT_MS = 15000;

  function startSavingNoteTimeout() {
    clearTimeout(_savingNoteTimeout);
    _savingNoteTimeout = setTimeout(function () {
      if (_isSavingNote) {
        console.warn('[dd-mini-cart] _isSavingNote stuck for 15s — force-resetting');
        _isSavingNote = false;
      }
      _savingNoteTimeout = null;
    }, NOTE_SAFETY_TIMEOUT_MS);
  }

  function clearSavingNoteTimeout() {
    clearTimeout(_savingNoteTimeout);
    _savingNoteTimeout = null;
  }
  var _protCountdownOn = false;
  var _protCountdownTimer = null;
  var _checkoutWarned = false;
  var _checkoutWarnResetTimer = null;
  var _cartStatusTimer = null;
  var _upsellCache = {}; // Session-lifetime, per-seed product; cleared on cart empty or full navigation.
  var _upsellInflight = {};
  var _upsellSeedLoaded = 0;
  var _lineMutationTokens = {};
  var _linePendingQty = {};
  var _checkoutNavTs = 0;
  var _footerExpanded = true;
  var FOOTER_TOGGLE_SEL = '[data-dd-footer-toggle]';
  var FOOTER_DETAILS_SEL = '[data-dd-footer-details]';
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var LINE_QTY_DEBOUNCE_MS = 120;

  /* ── Debouncing for event handlers ───────────────── */
  var _cartUpdateDebounceTimer = null;
  var _drawerOpenDebounceTimer = null;
  var _lastCartUpdateTs = 0;
  var _consentStateCache = null;
  var CART_UPDATE_DEBOUNCE_MS = 80;
  var DRAWER_OPEN_DEBOUNCE_MS = 50;

  function isEnterKey(e) {
    return !!e && (e.key === 'Enter' || e.code === 'NumpadEnter');
  }

  function getScopedRoot(fromEl) {
    if (fromEl && fromEl.closest) {
      var drawerRoot = fromEl.closest('cart-drawer');
      if (drawerRoot) return drawerRoot;
      var cartFooter = fromEl.closest('#main-cart-footer');
      if (cartFooter) return cartFooter;
    }
    return document;
  }

  function getScopedNode(fromEl, selector) {
    var root = getScopedRoot(fromEl);
    if (root && typeof root.querySelector === 'function') {
      var scoped = root.querySelector(selector);
      if (scoped) return scoped;
    }
    return document.querySelector(selector);
  }

  function isMiniCartScope(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('cart-drawer[data-dd-cart-shell="mini"], #CartDrawer, #CartDrawer-Form, [data-dd-cart-items]');
  }

  function getActiveSurfaceRoot(fromEl) {
    if (fromEl && fromEl.closest) {
      var scoped = fromEl.closest('cart-drawer, #main-cart-footer');
      if (scoped) return scoped;
    }
    var drawerRoot = document.getElementById('CartDrawer');
    if (drawerRoot) return drawerRoot;
    if (window.location.pathname.indexOf('/cart') === 0) {
      var cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) return cartFooter;
    }
    return document;
  }

  function getSurfaceNode(fromEl, selector) {
    var root = getActiveSurfaceRoot(fromEl);
    if (!root || typeof root.querySelector !== 'function') return null;
    return root.querySelector(selector);
  }

  function isElementInteractable(el) {
    if (!el || el.disabled) return false;
    if (el.hidden || el.type === 'hidden') return false;
    var style = window.getComputedStyle(el);
    if (!style) return true;
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (style.opacity === '0' && el.getClientRects().length === 0) return false;
    return true;
  }

  function getCartStatusEl() {
    return document.getElementById('CartDrawer-LiveRegionText');
  }

  function getLineItemStatusEl() {
    return document.getElementById('CartDrawer-LineItemStatus');
  }

  function setLineItemBusy(active) {
    var lineStatus = getLineItemStatusEl();
    if (!lineStatus) return;
    lineStatus.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  function announceCartStatus(message) {
    var text = (message || '').trim();
    if (!text) return;
    var cartStatus = getCartStatusEl();
    if (!cartStatus) return;
    clearTimeout(_cartStatusTimer);
    cartStatus.textContent = text;
    cartStatus.setAttribute('aria-hidden', 'false');
    _cartStatusTimer = setTimeout(function () {
      cartStatus.setAttribute('aria-hidden', 'true');
    }, 1200);
  }

  document.addEventListener('click', function (e) {
    var clickTarget = e && e.target;
    if (clickTarget && clickTarget.nodeType === 3) clickTarget = clickTarget.parentElement;
    if (!clickTarget || typeof clickTarget.closest !== 'function') return;

    /* Drawer-only scoping for footer/accordion toggles. Both surfaces
       (drawer + cart-page) use the same `data-dd-footer-toggle` /
       `data-dd-accordion-toggle` hooks for SSR parity, but each
       surface owns its own click handling — `dd-cart-page.js` runs a
       separate capture-phase `document` click listener for the cart
       page (`#main-cart-footer`). Without this scope check, both
       listeners fire on a cart-page click and toggle `is--open` in
       sequence, leaving the accordion in its prior state (the
       second toggle undoes the first). Scoping to `#CartDrawer`
       leaves cart-page clicks to the cart-page listener. */
    var footerToggle = clickTarget.closest(FOOTER_TOGGLE_SEL);
    if (footerToggle && footerToggle.closest('#CartDrawer')) {
      e.preventDefault();
      setFooterExpanded(!_footerExpanded);
      return;
    }

    var accordionToggle = clickTarget.closest('[data-dd-accordion-toggle]');
    if (accordionToggle && accordionToggle.closest('#CartDrawer')) {
      e.preventDefault();
      toggleAccordion(accordionToggle);
      return;
    }

    var upsellAdd = clickTarget.closest('[data-dd-upsell-add]');
    if (upsellAdd) { e.preventDefault(); handleUpsellAdd(upsellAdd); return; }

    var minus = clickTarget.closest('[data-dd-qty-minus]');
    if (minus && isMiniCartScope(minus)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleQtyChange(minus, -1);
      return;
    }

    var plus = clickTarget.closest('[data-dd-qty-plus]');
    if (plus && isMiniCartScope(plus)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleQtyChange(plus, 1);
      return;
    }

    var remove = clickTarget.closest('[data-dd-remove-item]');
    if (remove && isMiniCartScope(remove)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleRemove(remove);
      return;
    }

    var noteSave = clickTarget.closest('[data-dd-note-save]');
    if (noteSave) { e.preventDefault(); handleNoteSave(noteSave); return; }

    var noteBadgeRemove = clickTarget.closest('[data-dd-note-badge-remove]');
    if (noteBadgeRemove) { e.preventDefault(); clearNote(noteBadgeRemove); return; }

    var drawerRoot = document.getElementById('CartDrawer');
    if (drawerRoot && drawerRoot.contains(clickTarget)) {
      var discBadge = clickTarget.closest('[data-dd-discount-badge]');
      if (
        discBadge &&
        discBadge.closest('[data-dd-cart-discounts]') &&
        !clickTarget.closest('.dd-cart-discount__remove') &&
        (discBadge.getAttribute('data-discount-type') || '').trim() === 'discount_code'
      ) {
        e.preventDefault();
        setDrawerAccordionOpen(drawerRoot, 'discount', true);
        requestAnimationFrame(function () {
          var inp = drawerRoot.querySelector('[data-dd-discount-input]');
          if (inp && typeof inp.focus === 'function') {
            inp.focus();
            try {
              if (typeof inp.select === 'function') inp.select();
            } catch (ex) {}
          }
        });
        return;
      }
      var noteBadge = clickTarget.closest('[data-dd-note-badge]');
      if (noteBadge && noteBadge.closest('[data-dd-cart-discounts]') && !clickTarget.closest('[data-dd-note-badge-remove]')) {
        e.preventDefault();
        setDrawerAccordionOpen(drawerRoot, 'note', true);
        requestAnimationFrame(function () {
          var ni = drawerRoot.querySelector('[data-dd-note-input]');
          if (ni && typeof ni.focus === 'function') ni.focus();
        });
        return;
      }
    }
  }, true);

  document.addEventListener(
    'keydown',
    function (e) {
      var keyTarget = e && e.target;
      if (keyTarget && keyTarget.nodeType === 3) keyTarget = keyTarget.parentElement;
      if (!keyTarget || typeof keyTarget.closest !== 'function') return;
      /* Drawer-only — see click-delegation comment above. The cart
         page's footer toggle is keyboard-handled in dd-cart-page.js. */
      if (
        keyTarget.closest(FOOTER_TOGGLE_SEL) &&
        keyTarget.closest('#CartDrawer') &&
        (e.key === 'Enter' || e.key === ' ')
      ) {
        e.preventDefault();
        setFooterExpanded(!_footerExpanded);
        return;
      }
      if (!isEnterKey(e)) return;
      /* Qty inputs live inside #CartDrawer-Form; Enter would implicit-submit the form
         (often activating the Pay now button via form="") → full navigation / crash. */
      if (keyTarget.matches && keyTarget.matches('[data-dd-qty-input]')) {
        if (!isMiniCartScope(keyTarget)) return;
        e.preventDefault();
        e.stopPropagation();
        var qIn = keyTarget;
        var q = parseInt(qIn.value, 10);
        if (isNaN(q) || q < 0) q = 0;
        qIn.setAttribute('data-dd-skip-next-change', 'true');
        var prevFromEnter = parseInt(qIn.getAttribute('data-dd-prev-qty') || '', 10);
        if (isNaN(prevFromEnter)) prevFromEnter = null;
        if (prevFromEnter != null && q === prevFromEnter) {
          qIn.value = String(prevFromEnter);
          return;
        }
        if (qIn.dataset.lineKey) {
          var qLine = parseInt(qIn.dataset.line || '0', 10) || 0;
          updateItemQuantity(qIn.dataset.lineKey, qLine, q, null, prevFromEnter, qIn);
        }
        return;
      }
      if (keyTarget.closest('[data-dd-discount-input]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var discountInput = keyTarget.closest('[data-dd-discount-input]');
        var discountBox = discountInput ? discountInput.closest('[data-dd-discount]') : null;
        var applyBtn = discountBox ? discountBox.querySelector('[data-dd-discount-apply]') : null;
        if (applyBtn) applyBtn.click();
        return;
      }
      if (keyTarget.closest('[data-dd-discount-apply]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var directApplyBtn = keyTarget.closest('[data-dd-discount-apply]');
        if (directApplyBtn) directApplyBtn.click();
        return;
      }
      if (keyTarget.closest('[data-dd-note-input]')) {
        e.preventDefault();
        handleNoteSave(keyTarget);
        return;
      }
      if (keyTarget.closest('[data-dd-note-save]')) {
        e.preventDefault();
        handleNoteSave(keyTarget);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.id !== 'CartDrawer-Form') return;
      var sub = e.submitter || document.activeElement;
      var isCheckout =
        sub &&
        (sub.name === 'checkout' ||
          sub.getAttribute('data-dd-checkout') != null ||
          sub.id === 'CartDrawer-Checkout');
      if (isCheckout) return;
      e.preventDefault();
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-dd-qty-input]')) return;
    var input = e.target;
    if (!isMiniCartScope(input)) return;
    e.stopImmediatePropagation();
    if (input.getAttribute('data-dd-skip-next-change') === 'true') {
      input.removeAttribute('data-dd-skip-next-change');
      return;
    }
    var rawVal = parseInt(input.value, 10);
    var prevFromChange = parseInt(input.getAttribute('data-dd-prev-qty') || '', 10);
    if (isNaN(prevFromChange)) prevFromChange = null;

    if (isNaN(rawVal) || rawVal < 0) {
      var revert = prevFromChange != null ? prevFromChange : 1;
      input.value = String(revert);
      return;
    }
    var qty = rawVal;
    if (prevFromChange != null && qty === prevFromChange) {
      input.value = String(prevFromChange);
      return;
    }
    var changeLine = parseInt(input.dataset.line || '0', 10) || 0;
    updateItemQuantity(input.dataset.lineKey, changeLine, qty, null, prevFromChange, input);
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('[data-dd-qty-input]')) return;
    if (!isMiniCartScope(e.target)) return;
    var input = e.target;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.setAttribute('data-dd-prev-qty', String(qty));
  });

  function handleQtyChange(btn, delta) {
    if (!isMiniCartScope(btn) || btn.disabled) return;
    var container = btn.closest('[data-dd-qty-controls]');
    if (!container) return;
    var input = container.querySelector('[data-dd-qty-input]');
    if (!input || input.disabled) return;
    var row = btn.closest('[data-dd-cart-item]');
    var lineKey = input.dataset.lineKey || btn.dataset.lineKey || (row && row.dataset ? row.dataset.lineKey : '');
    var lineNumber = parseInt(
      input.dataset.line ||
        btn.dataset.line ||
        ((row && row.dataset && row.dataset.line) || '0'),
      10
    ) || 0;

    var current = parseInt(input.value, 10) || 0;
    var newQty = Math.max(0, current + delta);
    if (newQty === current) return;
    input.value = newQty;

    updateItemQuantity(lineKey, lineNumber, newQty, null, current, input);
  }

  function handleRemove(btn) {
    if (!isMiniCartScope(btn) || btn.disabled) return;
    var item = btn.closest('[data-dd-cart-item]');
    var lineKey = (item && item.dataset ? item.dataset.lineKey : '') || btn.dataset.lineKey || '';
    var lineNumber = parseInt(
      ((item && item.dataset && item.dataset.line) || btn.dataset.line || '0'),
      10
    ) || 0;
    var itemTitle = item ? (item.querySelector('.dd-cart-item__name') || {}).textContent || '' : '';
    updateItemQuantity(lineKey, lineNumber, 0, itemTitle, null, btn);
  }

  function handleUpsellAdd(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;
    if (btn.disabled) return;

    btn.disabled = true;
    var prior = btn.textContent;
    btn.textContent = 'Adding...';
    var ok = false;

    helpers
      .cartMutate('/cart/add.js', {
        items: [{ id: variantId, quantity: 1 }]
      }, { action: 'upsell-add' })
      .then(function () {
        ok = true;
        btn.textContent = 'Added!';
        announceCartStatus('Item added to cart');
        if (window.ddToast) window.ddToast('Item added to cart', { type: 'success' });
      })
      .catch(function (err) {
        btn.textContent = prior || 'Add';
        btn.disabled = false;
        var parsed = helpers.parseCartStockError
          ? helpers.parseCartStockError(err, { operation: 'add', requestedQty: 1 })
          : null;
        var stockMsg = parsed && helpers.stockErrorMessage
          ? helpers.stockErrorMessage(parsed, { operation: 'add' })
          : null;
        var msg = (stockMsg && stockMsg.message) || 'Couldn\u2019t add item \u2014 please try again';
        var type = (stockMsg && stockMsg.toastType) || 'error';
        announceCartStatus('Could not add item');
        if (window.ddToast) window.ddToast(msg, { type: type });
      })
      .finally(function () {
        if (!ok) return;
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = prior || 'Add';
        }, 1200);
      });
  }

  function updateNotePreview(note, fromEl) {
    var preview = getSurfaceNode(fromEl, '[data-dd-note-preview]');
    if (!preview) return;
    var text = (note || '').trim();
    if (!text) {
      preview.textContent = '';
      return;
    }
    var clipped = text.length > 28 ? text.slice(0, 28).trimEnd() + '\u2026' : text;
    preview.textContent = '"' + clipped + '"';
  }

  function updateNoteBadge(note, fromEl) {
    var discountsEl = getSurfaceNode(fromEl, '[data-dd-cart-discounts]');
    if (!discountsEl) return;
    var existing = discountsEl.querySelector('[data-dd-note-badge]');
    var text = (note || '').trim();
    if (!text) {
      if (existing) existing.remove();
      return;
    }
    var clipped = text.length > 28 ? text.slice(0, 28).trimEnd() + '\u2026' : text;
    if (existing) {
      var span = existing.querySelector('span');
      if (span) span.textContent = clipped;
      return;
    }
    var badge = document.createElement('div');
    badge.className = 'dd-cart-discount dd-cart-note-badge';
    badge.setAttribute('data-dd-note-badge', '');
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
        '<polyline points="14 2 14 8 20 8"/>' +
      '</svg>' +
      '<span>' + clipped.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' +
      '<button type="button" class="dd-cart-discount__remove" data-dd-note-badge-remove aria-label="Clear order note">' +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none">' +
          '<path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>';
    discountsEl.appendChild(badge);
  }

  function clearNote(fromEl) {
    if (_isSavingNote) return;
    _isSavingNote = true;
    startSavingNoteTimeout();
    var input = getSurfaceNode(fromEl, '[data-dd-note-input]');
    helpers
      .mutateCartUpdate(
        { note: '' },
        {
          includeSections: false,
          action: 'note-save',
          coalesceKey: helpers.makeCoalesceKey('note-save')
        }
      )
      .then(function () {
        updateNoteBadge('', fromEl);
        updateNotePreview('', fromEl);
        if (input) {
          input.value = '';
          input.dataset.ddInitialNote = '';
        }
        announceCartStatus('Note cleared');
        if (window.ddToast) window.ddToast('Note cleared', { type: 'info' });
      })
      .catch(function (err) {
        console.error('[dd-mini-cart] note clear error', err);
        if (window.ddToast) window.ddToast('Couldn\u2019t clear note \u2014 please try again', { type: 'error' });
      })
      .finally(function () {
        _isSavingNote = false;
        clearSavingNoteTimeout();
      });
  }

  function hasUnsavedDiscount(fromEl) {
    var input = getScopedNode(fromEl, '[data-dd-discount-input]');
    if (!input) return false;
    return (input.value || '').trim() !== '';
  }

  function hasUnsavedNote(fromEl) {
    var input = getScopedNode(fromEl, '[data-dd-note-input]');
    if (!input) return false;
    var saved = (input.dataset.ddInitialNote || '').trim();
    return (input.value || '').trim() !== saved;
  }

  function shakeEl(el) {
    if (!el) return;
    el.classList.remove('is--shake');
    void el.offsetWidth;
    el.classList.add('is--shake');
    el.addEventListener('animationend', function handler() {
      el.classList.remove('is--shake');
      el.removeEventListener('animationend', handler);
    });
  }

  function highlightUnsavedFields(unsavedDiscount, unsavedNote, fromEl) {
    if (unsavedDiscount) {
      var dLabel = getSurfaceNode(fromEl, '[data-dd-discount-label]');
      shakeEl(dLabel);
      setAccordionOpen('discount', true, fromEl);
    }
    if (unsavedNote) {
      var nLabel = getSurfaceNode(fromEl, '[data-dd-note-label]');
      shakeEl(nLabel);
      setAccordionOpen('note', true, fromEl);
    }
  }

  function accordionNodeByTarget(target, fromEl) {
    if (target === 'discount') return getSurfaceNode(fromEl, '[data-dd-discount-accordion]');
    if (target === 'note') return getSurfaceNode(fromEl, '[data-dd-note-accordion]');
    return null;
  }

  /** Open/close discount or note accordion inside a specific drawer root (#CartDrawer). */
  function setDrawerAccordionOpen(drawerEl, target, open) {
    if (!drawerEl || !drawerEl.querySelector) return;
    if (open) expandFooterDetails();
    var accordion =
      target === 'discount'
        ? drawerEl.querySelector('[data-dd-discount-accordion]')
        : target === 'note'
          ? drawerEl.querySelector('[data-dd-note-accordion]')
          : null;
    if (!accordion) return;
    accordion.classList.toggle('is--open', !!open);
    var toggle = accordion.querySelector('[data-dd-accordion-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setAccordionOpen(target, open, fromEl) {
    if (open) expandFooterDetails();
    var drawer = fromEl && fromEl.closest ? fromEl.closest('#CartDrawer') : document.getElementById('CartDrawer');
    if (drawer) {
      setDrawerAccordionOpen(drawer, target, open);
      return;
    }
    var accordion = accordionNodeByTarget(target, fromEl);
    if (!accordion) return;
    accordion.classList.toggle('is--open', !!open);
    var toggle = accordion.querySelector('[data-dd-accordion-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggleAccordion(toggleBtn) {
    var target = String(toggleBtn.getAttribute('data-dd-accordion-target') || '');
    if (!target) return;
    var drawer = toggleBtn.closest('#CartDrawer');
    if (drawer) {
      var acc =
        target === 'discount'
          ? drawer.querySelector('[data-dd-discount-accordion]')
          : target === 'note'
            ? drawer.querySelector('[data-dd-note-accordion]')
            : null;
      if (!acc) return;
      var nextOpen = !acc.classList.contains('is--open');
      setDrawerAccordionOpen(drawer, target, nextOpen);
      return;
    }
    var accordion = accordionNodeByTarget(target, toggleBtn);
    if (!accordion) return;
    var nextOpen = !accordion.classList.contains('is--open');
    setAccordionOpen(target, nextOpen, toggleBtn);
  }

  /* ── Collapsible footer (mobile) ────────────────── */

  function getFooterRoot() {
    var drawerRoot = getDrawerRoot();
    if (drawerRoot) {
      var drawerFooter = drawerRoot.querySelector('.dd-drawer-footer');
      if (drawerFooter) return drawerFooter;
    }
    return document.querySelector('#main-cart-footer .dd-drawer-footer') || document.querySelector('.dd-drawer-footer');
  }

  function setFooterExpanded(expanded) {
    _footerExpanded = !!expanded;
    var footer = getFooterRoot();
    if (!footer) return;
    footer.classList.toggle('is--collapsed', !_footerExpanded);
    var toggle = footer.querySelector(FOOTER_TOGGLE_SEL);
    if (toggle) {
      toggle.setAttribute('aria-expanded', _footerExpanded ? 'true' : 'false');
    }
  }

  function expandFooterDetails() {
    if (!_footerExpanded && MOBILE_MQ.matches) setFooterExpanded(true);
  }

  function collapseFooterDetails() {
    if (_footerExpanded && MOBILE_MQ.matches) setFooterExpanded(false);
  }

  function reapplyFooterState() {
    var footer = getFooterRoot();
    if (!footer) return;
    if (MOBILE_MQ.matches) {
      footer.classList.toggle('is--collapsed', !_footerExpanded);
      var toggle = footer.querySelector(FOOTER_TOGGLE_SEL);
      if (toggle) {
        toggle.setAttribute('aria-expanded', _footerExpanded ? 'true' : 'false');
      }
    }
  }

  function clearCheckoutWarnState() {
    _checkoutWarned = false;
    clearTimeout(_checkoutWarnResetTimer);
    _checkoutWarnResetTimer = null;
  }

  function handleNoteSave(fromEl) {
    if (_isSavingNote) return;
    var input = getScopedNode(fromEl, '[data-dd-note-input]');
    if (!input) return;
    var note = input.value;
    var saved = (input.dataset.ddInitialNote || '').trim();
    if ((note || '').trim() === saved) {
      announceCartStatus('Note already saved');
      if (window.ddToast) window.ddToast('Note is already saved', { type: 'info' });
      return;
    }

    _isSavingNote = true;
    startSavingNoteTimeout();
    helpers
      .mutateCartUpdate(
        { note: note },
        {
          includeSections: false,
          action: 'note-save',
          coalesceKey: helpers.makeCoalesceKey('note-save')
        }
      )
      .then(function () {
        var msg = note.trim() === '' ? 'Note cleared' : 'Note saved';
        updateNotePreview(note, fromEl);
        updateNoteBadge(note, fromEl);
        input.dataset.ddInitialNote = note.trim();
        announceCartStatus(msg);
        if (window.ddToast) window.ddToast(msg, { type: 'info' });
        if (typeof helpers.scheduleCloseCartAccordions === 'function') {
          helpers.scheduleCloseCartAccordions(input);
        }
      })
      .catch(function (err) {
        console.error('[dd-mini-cart] note save error', err);
        announceCartStatus('Could not save note');
        if (window.ddToast) window.ddToast('Couldn\u2019t save note \u2014 please try again', { type: 'error' });
      })
      .finally(function () {
        _isSavingNote = false;
        clearSavingNoteTimeout();
      });
  }

  function findItemGroup(lineKey) {
    if (!lineKey) return null;
    var nodes = document.querySelectorAll('[data-dd-cart-item]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.lineKey === lineKey) return nodes[i].closest('.dd-item-group');
    }
    return null;
  }

  function findQtyInput(lineKey) {
    if (!lineKey) return null;
    return document.querySelector('[data-dd-qty-input][data-line-key="' + lineKey + '"]');
  }

  function findQtyInputByLine(lineNumber) {
    if (!lineNumber || lineNumber < 1) return null;
    return document.querySelector('[data-dd-qty-input][data-line="' + String(lineNumber) + '"]');
  }

  function resolveLineIdentity(lineKey, lineNumber, sourceEl) {
    var resolvedKey = lineKey ? String(lineKey) : '';
    var resolvedLine = parseInt(lineNumber || '0', 10) || 0;

    var row = sourceEl && sourceEl.closest ? sourceEl.closest('[data-dd-cart-item]') : null;
    if (!row && resolvedKey) {
      var rowsByKey = document.querySelectorAll('[data-dd-cart-item]');
      for (var i = 0; i < rowsByKey.length; i++) {
        if ((rowsByKey[i].dataset && rowsByKey[i].dataset.lineKey) === resolvedKey) {
          row = rowsByKey[i];
          break;
        }
      }
    }

    if (row && row.dataset) {
      if (!resolvedKey && row.dataset.lineKey) resolvedKey = String(row.dataset.lineKey);
      if (!resolvedLine && row.dataset.line) {
        var parsedLine = parseInt(row.dataset.line, 10);
        if (parsedLine > 0) resolvedLine = parsedLine;
      }
    }

    return {
      lineKey: resolvedKey,
      lineNumber: resolvedLine
    };
  }

  function resolveVariantIdFromSource(lineKey, sourceEl) {
    var row = sourceEl && sourceEl.closest ? sourceEl.closest('[data-dd-cart-item]') : null;
    if (!row && lineKey) {
      row = document.querySelector('[data-dd-cart-item][data-line-key="' + lineKey + '"]');
    }
    if (!row) return 0;
    return parseInt(row.getAttribute('data-variant-id') || '0', 10) || 0;
  }

  function isProtectionLikeItem(item) {
    if (!item) return false;
    if (Number(item.product_id || 0) === 10266015924541) return true;
    var props = item.properties && typeof item.properties === 'object' ? item.properties : null;
    if (props && (props._dd_shipping_protection || props.dd_shipping_protection)) return true;
    var h = String(item.handle || '').toLowerCase();
    var v = String(item.vendor || '').toLowerCase();
    var t = String(item.title || '').toLowerCase();
    return (
      h === 'dd-shipping-protection' ||
      v.indexOf('insureshield') !== -1 ||
      v.indexOf('insure shield') !== -1 ||
      t.indexOf('shipping protection') !== -1 ||
      t.indexOf('shipping insurance') !== -1
    );
  }

  function setLineInputToQty(lineKey, lineNumber, qty) {
    if (qty == null || isNaN(qty)) return null;
    if (!lineKey) return null;
    var input = findQtyInput(lineKey);
    if (!input) return null;
    var next = parseInt(qty, 10);
    if (isNaN(next) || next < 0) next = 0;
    input.value = String(next);
    input.setAttribute('data-dd-prev-qty', String(next));
    return input;
  }

  function parseLineQtyEdgeConstraint(err, requestedQty, previousQty) {
    var h = window.ddCartHelpers;
    if (!h || !h.parseCartStockError) return null;
    var parsed = h.parseCartStockError(err, {
      operation: 'change',
      requestedQty: requestedQty,
      previousQty: previousQty
    });
    if (!parsed) return null;
    if (parsed.kind === 'stale-line') return null;
    var stockMsg = h.stockErrorMessage(parsed, { operation: 'change' });
    return {
      message: stockMsg ? stockMsg.message : null,
      toastType: stockMsg ? stockMsg.toastType : 'error',
      allowedQty: parsed.allowedQty
    };
  }

  function getLineMutationErrorStatus(err) {
    return Number(
      (err && (err.shopifyStatus || err.status)) ||
        (err && err.responseBody && err.responseBody.status) ||
        0
    );
  }

  function getLineMutationErrorText(err) {
    var parts = [];
    if (err && err.responseBody) {
      if (err.responseBody.description) parts.push(String(err.responseBody.description));
      if (err.responseBody.message) parts.push(String(err.responseBody.message));
      if (err.responseBody.errors) {
        if (typeof err.responseBody.errors === 'string') parts.push(err.responseBody.errors);
        else {
          try {
            parts.push(JSON.stringify(err.responseBody.errors));
          } catch (_) {}
        }
      }
    }
    if (err && err.description) parts.push(String(err.description));
    if (err && err.message) parts.push(String(err.message));
    return parts.join(' ').replace(/[\u2018\u2019]/g, "'");
  }

  function buildLineQtyMutationToast(err, requestedQty, previousQty, isRemoval) {
    var h = window.ddCartHelpers;
    var parsed = h && h.parseCartStockError
      ? h.parseCartStockError(err, { operation: 'change', requestedQty: requestedQty, previousQty: previousQty })
      : null;
    if (parsed) {
      var stockMsg = h.stockErrorMessage(parsed, { operation: 'change' });
      if (stockMsg) return { message: stockMsg.message, type: stockMsg.toastType || 'error' };
    }

    var status = getLineMutationErrorStatus(err);
    var raw = getLineMutationErrorText(err);
    var lowered = raw.toLowerCase();

    if (
      status === 400 ||
      /no valid id or line parameter|line item not found|line .* invalid|cart error/.test(lowered)
    ) {
      return {
        message: 'Cart changed in the background. Please try that quantity update again.',
        type: 'info',
      };
    }

    if (err && err.description) {
      var normParsed = h && h.parseCartStockError
        ? h.parseCartStockError(err, { operation: 'change' })
        : null;
      var normMsg = normParsed && h.stockErrorMessage(normParsed, { operation: 'change' });
      if (normMsg) return { message: normMsg.message, type: normMsg.toastType || 'error' };
      return { message: String(err.description), type: 'error' };
    }

    if (isRemoval) {
      return { message: 'Couldn\u2019t remove item \u2014 please try again', type: 'error' };
    }

    return { message: 'Couldn\u2019t update cart \u2014 please try again', type: 'error' };
  }

  function getCommittedQtyFromCart(cart, lineKey, lineNumber, sourceEl) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    if (!items.length) return null;

    if (lineKey) {
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].key || '') === String(lineKey)) {
          return parseInt(items[i].quantity, 10) || 0;
        }
      }
    }

    return null;
  }

  function deriveLineQtySuccessEdgeToast(cart, lineKey, lineNumber, requestedQty, sourceEl) {
    if (!(requestedQty > 0)) return null;
    var committedQty = getCommittedQtyFromCart(cart, lineKey, lineNumber, sourceEl);
    if (committedQty == null) {
      return null;
    }
    if (committedQty >= requestedQty) return { committedQty: committedQty };

    if (committedQty > 0) {
      return {
        committedQty: committedQty,
        message: 'Only ' + committedQty + ' available \u2014 quantity has been adjusted.',
        toastType: 'info',
      };
    }

    return {
      committedQty: committedQty,
      message: 'No more stock is available for this option.',
      toastType: 'error',
    };
  }

  function readCommittedQtyFromServer(lineKey, lineNumber, sourceEl) {
    var cartPromise;
    if (window.ddCartHelpers && typeof window.ddCartHelpers.ensureFreshCart === 'function') {
      cartPromise = window.ddCartHelpers.ensureFreshCart({ forceNetwork: true });
    } else {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart read failed (' + r.status + ')');
          return r.json();
        })
        .then(function (cart) {
          return getCommittedQtyFromCart(cart, lineKey, lineNumber, sourceEl);
        });
    }
    return cartPromise.then(function (cart) {
      return getCommittedQtyFromCart(cart, lineKey, lineNumber, sourceEl);
    });
  }

  function silentDrawerRefresh() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.fetchMissingSections === 'function') {
      cd.fetchMissingSections()
        .then(function (sections) {
          if (sections && sections['cart-drawer'] && cd.renderContents) {
            cd.renderContents({ sections: sections });
          }
        })
        .catch(function () {});
    }
  }

  function retryLineChangeWithFreshIdentity(variantId, attemptedKey, attemptedLine, qty) {
    if (!variantId) return Promise.resolve(null);
    var cartPromise;
    if (window.ddCartHelpers && typeof window.ddCartHelpers.ensureFreshCart === 'function') {
      cartPromise = window.ddCartHelpers.ensureFreshCart({ forceNetwork: true });
    } else {
      cartPromise = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('Retry cart read failed (' + r.status + ')');
          return r.json();
        });
    }
    return cartPromise
      .then(function (cart) {
        var items = Array.isArray(cart && cart.items) ? cart.items : [];
        var matches = [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (isProtectionLikeItem(it)) continue;
          if (Number(it.variant_id) === Number(variantId)) {
            matches.push({ item: it, line: i + 1 });
          }
        }
        if (!matches.length) return null;

        var pick = matches[0];
        if (matches.length > 1 && attemptedKey) {
          var colonIdx = attemptedKey.indexOf(':');
          var propsHash = colonIdx > 0 ? attemptedKey.substring(colonIdx + 1) : '';
          for (var m = 0; m < matches.length; m++) {
            var mKey = matches[m].item.key || '';
            if (mKey === attemptedKey) { pick = matches[m]; break; }
            var mColon = mKey.indexOf(':');
            var mHash = mColon > 0 ? mKey.substring(mColon + 1) : '';
            if (propsHash && mHash === propsHash) { pick = matches[m]; break; }
          }
        }

        var fresh = pick.item;
        if (fresh.key === attemptedKey) return null;
        var retryBody = { id: fresh.key, quantity: qty };
        return helpers.mutateCartChange(
          retryBody,
          {
            granular: qty !== 0,
            action: 'line-qty-retry',
            coalesceKey: helpers.makeCoalesceKey('line', fresh.key || variantId)
          }
        );
      })
      .catch(function (err) {
        var status = Number(err && err.shopifyStatus);
        if (status === 422) throw err;
        console.warn('[dd-mini-cart] line-qty retry failed', err);
        return null;
      });
  }

  function nextLineMutationToken(mutationKey) {
    if (!mutationKey) return 0;
    var next = (_lineMutationTokens[mutationKey] || 0) + 1;
    _lineMutationTokens[mutationKey] = next;
    return next;
  }

  function isLatestLineMutation(mutationKey, token) {
    if (!mutationKey) return false;
    return (_lineMutationTokens[mutationKey] || 0) === token;
  }

  function setLineUpdating(lineKey, active) {
    var g = findItemGroup(lineKey);
    if (!g) return;
    g.classList.toggle('is--lineUpdating', !!active);
    var controls = g.querySelectorAll('[data-dd-qty-minus], [data-dd-qty-plus], [data-dd-remove-item], [data-dd-qty-input]');
    for (var i = 0; i < controls.length; i++) {
      if (active) controls[i].setAttribute('disabled', 'disabled');
      else controls[i].removeAttribute('disabled');
    }
  }

  function clearAllLineUpdating() {
    document.querySelectorAll('.dd-item-group.is--lineUpdating').forEach(function (el) {
      el.classList.remove('is--lineUpdating');
      var controls = el.querySelectorAll('[data-dd-qty-minus], [data-dd-qty-plus], [data-dd-remove-item], [data-dd-qty-input]');
      for (var i = 0; i < controls.length; i++) {
        controls[i].removeAttribute('disabled');
      }
    });
  }

  function executeItemQuantityUpdate(lineKey, lineNumber, qty, itemTitle, previousQty, sourceEl) {
    var identity = resolveLineIdentity(lineKey, lineNumber, sourceEl);
    lineKey = identity.lineKey;
    lineNumber = identity.lineNumber;
    if (!lineKey) {
      silentDrawerRefresh();
      return;
    }

    var isRemoval = qty === 0;
    var inputEl = findQtyInput(lineKey);
    var prevQty = previousQty;
    if (prevQty == null && inputEl) {
      var inputPrev = parseInt(inputEl.getAttribute('data-dd-prev-qty') || '', 10);
      if (!isNaN(inputPrev) && inputPrev >= 0) prevQty = inputPrev;
    }
    if (prevQty == null && helpers && typeof helpers.getLatestCart === 'function') {
      var latestBefore = helpers.getLatestCart();
      var latestQty = getCommittedQtyFromCart(latestBefore, lineKey, lineNumber, sourceEl);
      if (latestQty != null) prevQty = latestQty;
    }
    var mutationKey = lineKey;
    var mutationToken = nextLineMutationToken(mutationKey);
    clearAllLineUpdating();
    setLineUpdating(lineKey, true);
    setLineItemBusy(true);
    var body = { quantity: qty, id: lineKey };
    helpers.mutateCartChange(body, {
      granular: !isRemoval,
      action: qty === 0 ? 'line-remove' : 'line-qty-change',
      coalesceKey: helpers.makeCoalesceKey('line', lineKey || 'unknown')
    })
      .then(function (data) {
        if (!isLatestLineMutation(mutationKey, mutationToken)) return;
        updateDrawerUI(data);
        var successEdge = isRemoval
          ? null
          : deriveLineQtySuccessEdgeToast(data, lineKey, lineNumber, qty, sourceEl);
        if (isRemoval) {
          var msg = itemTitle ? (itemTitle.trim() + ' removed') : 'Item removed';
          announceCartStatus(msg);
        } else if (successEdge && typeof successEdge.committedQty === 'number' && !isNaN(successEdge.committedQty)) {
          setLineInputToQty(lineKey, lineNumber, Math.max(0, successEdge.committedQty));
          announceCartStatus('Cart updated');
          if (successEdge.message && window.ddToast) {
            window.ddToast(successEdge.message, { type: successEdge.toastType || 'info' });
          }
        } else {
          var freshInput = findQtyInput(lineKey);
          if (freshInput) {
            var serverVal = parseInt(freshInput.value, 10);
            if (!isNaN(serverVal) && serverVal >= 0) freshInput.setAttribute('data-dd-prev-qty', String(serverVal));
          }
          announceCartStatus('Cart updated');
        }
      })
      .catch(function (err) {
        if (!isLatestLineMutation(mutationKey, mutationToken)) return;

        var is400 = Number(err && err.shopifyStatus) === 400;
        var variantId = resolveVariantIdFromSource(lineKey, sourceEl);
        if (is400 && variantId) {
          return retryLineChangeWithFreshIdentity(variantId, lineKey, lineNumber || 0, qty)
            .then(function (retryData) {
              if (!retryData) {
                if (prevQty != null) setLineInputToQty(lineKey, lineNumber, prevQty);
                silentDrawerRefresh();
                return;
              }
              updateDrawerUI(retryData);
              var retryEdge = deriveLineQtySuccessEdgeToast(retryData, lineKey, lineNumber, qty, sourceEl);
              if (retryEdge && typeof retryEdge.committedQty === 'number' && retryEdge.committedQty < qty) {
                setLineInputToQty(lineKey, lineNumber, retryEdge.committedQty);
                announceCartStatus('Cart updated');
                if (retryEdge.message && window.ddToast) window.ddToast(retryEdge.message, { type: retryEdge.toastType || 'info' });
                return;
              }
              announceCartStatus('Cart updated');
            })
            .catch(function (retryErr) {
              if (!isLatestLineMutation(mutationKey, mutationToken)) return;
              var retryEdge = parseLineQtyEdgeConstraint(retryErr, qty, prevQty);
              if (retryEdge && retryEdge.message) {
                if (prevQty != null) setLineInputToQty(lineKey, lineNumber, prevQty);
                announceCartStatus('Cart updated');
                if (window.ddToast) window.ddToast(retryEdge.message, { type: retryEdge.toastType || 'info' });
                return;
              }
              if (prevQty != null) setLineInputToQty(lineKey, lineNumber, prevQty);
              silentDrawerRefresh();
            });
        }

        var edge = parseLineQtyEdgeConstraint(err, qty, prevQty);
        if (edge) {
          var edgeAllowed = typeof edge.allowedQty === 'number' && !isNaN(edge.allowedQty)
            ? Math.max(0, edge.allowedQty)
            : null;
          var status = getLineMutationErrorStatus(err);
          var isIncreaseAttempt = prevQty != null ? qty > prevQty : qty > 1;

          var finalizeEdge = function () {
            if (edgeAllowed != null && edgeAllowed === qty) {
              setLineInputToQty(lineKey, lineNumber, edgeAllowed);
              announceCartStatus('Cart updated');
              return;
            }

            if (edgeAllowed != null && edgeAllowed !== qty) {
              if (prevQty != null && edgeAllowed === prevQty) {
                setLineInputToQty(lineKey, lineNumber, edgeAllowed);
                announceCartStatus('Cart updated');
                if (window.ddToast) window.ddToast(edge.message, { type: edge.toastType || 'info' });
                return;
              }

              var adjustBody = { quantity: edgeAllowed };
              adjustBody.id = lineKey;

              return helpers
                .mutateCartChange(adjustBody, {
                  granular: edgeAllowed !== 0,
                  action: edgeAllowed === 0 ? 'line-remove' : 'line-qty-stock-adjust',
                  coalesceKey: helpers.makeCoalesceKey('line', lineKey || 'unknown')
                })
                .then(function (adjustData) {
                  if (!isLatestLineMutation(mutationKey, mutationToken)) return;
                  updateDrawerUI(adjustData);
                  setLineInputToQty(lineKey, lineNumber, edgeAllowed);
                  announceCartStatus('Cart updated');
                  if (window.ddToast) window.ddToast(edge.message, { type: edge.toastType || 'info' });
                })
                .catch(function () {
                  if (!isLatestLineMutation(mutationKey, mutationToken)) return;
                  if (prevQty != null) setLineInputToQty(lineKey, lineNumber, prevQty);
                  announceCartStatus('Could not update cart');
                  if (window.ddToast) window.ddToast(edge.message || 'No more stock is available for this option.', { type: 'error' });
                });
            }

            if (prevQty != null) setLineInputToQty(lineKey, lineNumber, prevQty);
            announceCartStatus('Could not update cart');
            if (window.ddToast) window.ddToast(edge.message || 'No more stock is available for this option.', { type: edge.toastType || 'error' });
          };

          if (status === 422 && isIncreaseAttempt) {
            return readCommittedQtyFromServer(lineKey, lineNumber, sourceEl)
              .then(function (serverQty) {
                if (!isLatestLineMutation(mutationKey, mutationToken)) return;
                if (typeof serverQty !== 'number' || isNaN(serverQty)) return;

                if (serverQty > 0 && serverQty < qty) {
                  edgeAllowed = serverQty;
                  edge.message = 'Only ' + serverQty + ' available \u2014 quantity has been adjusted.';
                  edge.toastType = 'info';
                  return;
                }

                if (prevQty != null && serverQty <= prevQty) {
                  edgeAllowed = prevQty;
                  edge.message =
                    serverQty === 0
                      ? 'This item is sold out for the selected option.'
                      : 'No more stock is available for this option.';
                  edge.toastType = 'error';
                  return;
                }

                if (serverQty >= qty) {
                  edgeAllowed = qty;
                }
              })
              .catch(function () {})
              .then(function () {
                return finalizeEdge();
              });
          }

          return finalizeEdge();
        }

        var fallbackToast = buildLineQtyMutationToast(err, qty, prevQty, isRemoval);
        var liveInput = findQtyInput(lineKey);
        if (liveInput && prevQty != null) {
          liveInput.value = String(prevQty);
          liveInput.setAttribute('data-dd-prev-qty', String(prevQty));
        }
        announceCartStatus('Could not update cart');
        if (window.ddToast) window.ddToast(fallbackToast.message, { type: fallbackToast.type || 'error' });
      })
      .finally(function () {
        if (!isLatestLineMutation(mutationKey, mutationToken)) return;
        var unlock = function () {
          clearAllLineUpdating();
          setLineItemBusy(false);
        };
        if (helpers.waitForIdle) {
          helpers.waitForIdle(4500).then(unlock);
        } else {
          unlock();
        }
      });
  }

  function updateItemQuantity(lineKey, lineNumber, qty, itemTitle, previousQty, sourceEl) {
    var identity = resolveLineIdentity(lineKey, lineNumber, sourceEl);
    lineKey = identity.lineKey;
    lineNumber = identity.lineNumber;
    if (!lineKey) {
      silentDrawerRefresh();
      return;
    }
    var isExplicitRemove = qty === 0 && !!itemTitle;
    var pendingKey = lineKey;
    var pending = _linePendingQty[pendingKey];

    if (isExplicitRemove) {
      if (pending && pending.timer) clearTimeout(pending.timer);
      delete _linePendingQty[pendingKey];
      executeItemQuantityUpdate(lineKey, lineNumber, qty, itemTitle, previousQty, sourceEl);
      return;
    }

    if (!pending) {
      pending = _linePendingQty[pendingKey] = {
        lineKey: lineKey,
        lineNumber: lineNumber || 0,
        qty: qty,
        itemTitle: itemTitle || '',
        previousQty: previousQty,
        sourceEl: sourceEl || null,
        timer: null
      };
    } else {
      pending.qty = qty;
      pending.itemTitle = itemTitle || pending.itemTitle || '';
      if (pending.previousQty == null && previousQty != null) pending.previousQty = previousQty;
      pending.sourceEl = sourceEl || pending.sourceEl || null;
      if (!pending.lineNumber && lineNumber) pending.lineNumber = lineNumber;
      if (pending.timer) clearTimeout(pending.timer);
    }

    pending.timer = setTimeout(function () {
      var latest = _linePendingQty[pendingKey];
      if (!latest) return;
      delete _linePendingQty[pendingKey];
      executeItemQuantityUpdate(
        latest.lineKey,
        latest.lineNumber,
        latest.qty,
        latest.itemTitle,
        latest.previousQty,
        latest.sourceEl
      );
    }, LINE_QTY_DEBOUNCE_MS);
  }

  function getDrawerThresholdEls() {
    var drawer =
      document.querySelector('cart-drawer[data-dd-cart-shell="mini"]') || document.querySelector('cart-drawer');
    if (!drawer) return null;
    var container = drawer.querySelector(THRESHOLD_SEL);
    if (!container) return null;
    var text = container.querySelector(THRESHOLD_TEXT_SEL);
    var track = container.querySelector('.dd-threshold__bar-wrap');
    if (!text || !track) return null;
    return { drawer: drawer, container: container, text: text, track: track };
  }

  function captureConsentState(drawer) {
    if (!drawer) return;
    var consent = drawer.querySelector(PROT_CONSENT_SEL);
    if (consent) {
      _consentStateCache = consent.checked;
    }
  }

  function restoreConsentState(drawer) {
    if (!drawer || _consentStateCache === null) return;
    var consent = drawer.querySelector(PROT_CONSENT_SEL);
    if (consent && consent.checked !== _consentStateCache) {
      consent.checked = _consentStateCache;
    }
  }

  function clearUpsellCacheOnEmpty() {
    _upsellCache = {};
    _upsellInflight = {};
    _upsellSeedLoaded = 0;
  }

  function updateDrawerUI(data) {
    var cart = data;
    if (!cart) return;

    /* Only update the badge when we have authoritative cart data (item_count is a number).
       /cart/add.js responses only contain the added items — not the full cart — so
       cartDisplayCount() would return 0 for those payloads and incorrectly zero-out the badge.
       The section HTML replacement (replaceSections) already rendered the correct count
       from the server for those cases. */
    if (typeof cart.item_count === 'number') {
      var count = helpers.cartDisplayCount(cart);
      if (count === 0 && cart.item_count > 0) count = cart.item_count;
      document.querySelectorAll(COUNT_SEL).forEach(function (el) {
        el.textContent = count;
      });
    }

    var drawer = document.querySelector('cart-drawer[data-dd-cart-shell="mini"]') || document.querySelector('cart-drawer');
    if (!drawer) return;

    /* Capture consent state BEFORE section replacement might lose it */
    captureConsentState(drawer);

    var empty = drawer.querySelector(EMPTY_SEL);
    var content = drawer.querySelector(CONTENT_SEL);

    /* Empty mode must be based on canonical cart state, not display count.
       Display count excludes protection lines by design, which is not the same
       as "cart has no items". */
    var hasAuthoritativeItemCount = typeof cart.item_count === 'number';
    var hasAuthoritativeItems = Array.isArray(cart.items);
    var isEmpty = null;
    if (hasAuthoritativeItemCount) {
      isEmpty = cart.item_count === 0;
    } else if (hasAuthoritativeItems) {
      isEmpty = cart.items.length === 0;
    }

    if (isEmpty !== null) {
      if (isEmpty) {
        drawer.classList.add('is-empty');
        /* Clear upsell cache when cart is empty to prevent stale recommendations */
        clearUpsellCacheOnEmpty();
      } else {
        drawer.classList.remove('is-empty');
      }

      if (empty) empty.style.display = isEmpty ? '' : 'none';
      if (content) content.style.display = isEmpty ? 'none' : '';
    }

    var thresholdCart = getAuthoritativeThresholdCart(cart);
    if (thresholdCart) updateThresholdBar(thresholdCart);

    var granularFooter =
      helpers.consumeGranularFooterPending && helpers.consumeGranularFooterPending();
    if (granularFooter && helpers.applyFooterFromCart) {
      helpers.applyFooterFromCart(drawer, cart);
    }
    var footerFreshFromSection =
      helpers &&
      typeof helpers.isSectionFooterFresh === 'function' &&
      helpers.isSectionFooterFresh();
    /* Section-rendered footer is authoritative when fresh; avoid immediately
       overwriting it with a cart payload that can omit per-line discount fields. */
    if (!footerFreshFromSection) {
      updateSubtotal(cart);
    }

    /* Restore consent state AFTER section replacement, then sync UI */
    restoreConsentState(drawer);
    syncProtectionConsentState(drawer);
    syncMiniUpsell(cart);
    reapplyFooterState();
  }

  function lineContributionCents(item) {
    if (isProtectionLikeItem(item)) return 0;
    var cents = item.final_line_price != null ? item.final_line_price : item.line_price;
    return Number(cents) || 0;
  }

  /** Sum non-protection line prices from /cart.js (cents). */
  function sumMerchSubtotalFromCartItems(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      sum += lineContributionCents(items[i]);
    }
    return sum;
  }

  /**
   * Same subtotal Liquid uses for free-shipping text (excl. protection).
   * When cart line items omit final_line_price (B2B / redaction), client sum is 0 but footer still uses total_price —
   * prefer data-dd-merch-subtotal-cents from the last section render (same mutation as this cart JSON).
   */
  function resolveMerchSubtotalCentsForShipping(container, cart) {
    var computed = sumMerchSubtotalFromCartItems(cart);
    if (!container || typeof container.getAttribute !== 'function') return computed;
    var raw = container.getAttribute('data-dd-merch-subtotal-cents');
    if (raw == null || raw === '') return computed;
    var dom = parseInt(raw, 10);
    if (!isFinite(dom) || dom < 0) return computed;
    if (computed === 0 && dom > 0) return dom;
    return computed;
  }

  function clearThresholdTimers() {
    clearTimeout(_thresholdGraceTimer);
    clearTimeout(_thresholdExitTimer);
    clearTimeout(_thresholdTextTimer);
    _thresholdGraceTimer = null;
    _thresholdExitTimer = null;
    _thresholdTextTimer = null;
  }

  function setThresholdText(textEl, html) {
    if (!textEl) return;
    if (textEl.innerHTML === html) return;
    textEl.innerHTML = html;
  }

  function swapThresholdText(textEl, html) {
    if (!textEl) return;
    textEl.classList.remove('is--swap-in');
    textEl.classList.add('is--swap-out');
    clearTimeout(_thresholdTextTimer);
    _thresholdTextTimer = setTimeout(function () {
      textEl.innerHTML = html;
      textEl.classList.remove('is--swap-out');
      void textEl.offsetWidth;
      textEl.classList.add('is--swap-in');
    }, THRESHOLD_TEXT_SWAP_MS);
  }

  function getAuthoritativeThresholdCart(cart) {
    if (cart && typeof cart.item_count === 'number' && Array.isArray(cart.items)) return cart;
    if (helpers.getLatestCart) {
      var latest = helpers.getLatestCart();
      if (latest && typeof latest.item_count === 'number' && Array.isArray(latest.items)) return latest;
    }
    return null;
  }

  function hasAuthoritativeCartData(cart) {
    return !!(
      cart &&
      typeof cart.item_count === 'number' &&
      Array.isArray(cart.items) &&
      typeof cart.total_price === 'number'
    );
  }

  function extractCartFromEventPayload(payload) {
    if (helpers && typeof helpers.extractCartFromEventDetail === 'function') {
      return helpers.extractCartFromEventDetail(payload);
    }
    if (!payload || typeof payload !== 'object') return null;
    if (hasAuthoritativeCartData(payload.cartData)) return payload.cartData;
    if (hasAuthoritativeCartData(payload.cart)) return payload.cart;
    if (hasAuthoritativeCartData(payload)) return payload;
    return null;
  }

  function updateThresholdBar(cart) {
    var els = getDrawerThresholdEls();
    if (!els) return;
    var container = els.container;
    var text = els.text;
    var track = els.track;

    var threshold = parseInt(container.dataset.ddThreshold, 10);
    if (!threshold || threshold <= 0) return;

    var subtotal = resolveMerchSubtotalCentsForShipping(container, cart);

    var pctRaw = Math.min(100, (subtotal / threshold) * 100);
    var pct = Math.round(pctRaw * 10) / 10;
    var nowMet = subtotal >= threshold;
    var fillPct = nowMet ? 100 : pct;
    var seg1 = Number(container.getAttribute('data-dd-threshold-seg-1') || 25);
    var seg2 = Number(container.getAttribute('data-dd-threshold-seg-2') || 50);
    var seg3 = Number(container.getAttribute('data-dd-threshold-seg-3') || 75);
    if (!isFinite(seg1)) seg1 = 25;
    if (!isFinite(seg2)) seg2 = 50;
    if (!isFinite(seg3)) seg3 = 75;
    var thresholdClass = String(seg1);
    if (nowMet) thresholdClass = '100';
    else if (pct < seg1) thresholdClass = String(seg1);
    else if (pct < seg2) thresholdClass = String(seg2);
    else if (pct < seg3) thresholdClass = String(seg3);
    else thresholdClass = '99.994';
    var congratsHTML =
      '<svg class="dd-threshold__check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span class="dd-threshold__congrats"><strong>Congratulations!</strong> You\'ve got free shipping!</span>';
    var neutralHTML;
    if (!isCustomerLoggedIn()) {
      neutralHTML = 'Free shipping on qualifying orders';
    } else if (subtotal <= 0) {
      neutralHTML = 'Free shipping on orders over ' + helpers.formatMoney(threshold);
    } else {
      neutralHTML = 'Add ' + helpers.formatMoney(threshold - subtotal) + ' more for free 2-day shipping';
    }
    var justReached = nowMet && _thresholdInitialized && !_prevThresholdMet;

    function paint() {
      track.style.setProperty('--dd-threshold-pct', fillPct + '%');
      var ariaPct = Math.round(pctRaw);
      track.setAttribute('aria-valuenow', String(nowMet ? 100 : ariaPct));
      track.setAttribute('aria-valuetext', fillPct + '% toward free shipping');
      container.setAttribute('data-dd-threshold-class', thresholdClass);

      if (justReached) {
        clearThresholdTimers();
        container.classList.remove('is--done');
        container.classList.add('is--celebrating');
        container.classList.remove('is--bar-exit');
        text.classList.remove('is--swap-out', 'is--swap-in');
        _thresholdGraceTimer = setTimeout(function () {
          container.classList.add('is--bar-exit');
          _thresholdExitTimer = setTimeout(function () {
            swapThresholdText(text, congratsHTML);
            container.classList.remove('is--celebrating');
            container.classList.add('is--done');
          }, THRESHOLD_EXIT_MS);
        }, THRESHOLD_GRACE_MS);
      } else if (nowMet) {
        clearThresholdTimers();
        container.classList.add('is--done');
        container.classList.remove('is--celebrating', 'is--bar-exit');
        text.classList.remove('is--swap-out');
        setThresholdText(text, congratsHTML);
      } else {
        clearThresholdTimers();
        container.classList.remove('is--done', 'is--celebrating', 'is--bar-exit');
        text.classList.remove('is--swap-out', 'is--swap-in');
        setThresholdText(text, neutralHTML);
      }

      _prevThresholdMet = nowMet;
      _thresholdInitialized = true;
    }

    if (helpers.withLocalShimmer) {
      helpers.withLocalShimmer(container, paint);
    } else {
      paint();
    }
  }

  function updateSubtotal(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var els = document.querySelectorAll('[data-dd-subtotal-money]');
    if (!els.length) return;
    var moneyFormatter =
      helpers && typeof helpers.formatMoneyWithCurrency === 'function'
        ? helpers.formatMoneyWithCurrency
        : helpers.formatMoney;
    var next = moneyFormatter(getDisplaySubtotal(cart));
    var allMatch = true;
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== next) allMatch = false;
    }
    if (allMatch) return;

    /* Shimmer the amount column only so "Subtotal" label stays visually stable */
    var host =
      els[0].closest('[data-dd-subtotal]') ||
      els[0].closest('.dd-subtotal__amount-row') ||
      els[0].parentElement;
    var money = getDisplaySubtotal(cart);
    function paint() {
      for (var j = 0; j < els.length; j++) {
        els[j].textContent = moneyFormatter(money);
      }
    }
    if (helpers.withLocalShimmer) {
      helpers.withLocalShimmer(host, paint);
    } else {
      paint();
    }
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function moneyFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) n = 0;
    if (helpers && typeof helpers.formatMoney === 'function') return helpers.formatMoney(n);
    // Fallback only used if helpers.formatMoney is missing (e.g. mini-cart
    // rendered before cart-notify loads). Mirror Liquid's
    // `money_without_trailing_zeros` so nothing flashes a trailing `.00`.
    var f = (n / 100).toFixed(2);
    return '$' + (f.slice(-3) === '.00' ? f.slice(0, -3) : f);
  }

  function isCustomerLoggedIn() {
    return document.documentElement.getAttribute('data-glass-customer') === 'true';
  }

  function getMerchItems(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      if (!isProtectionLikeItem(it)) out.push(it);
    }
    return out;
  }

  function sumAllFinalLinePricesCents(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var s = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      var v = it.final_line_price != null ? Number(it.final_line_price) : Number(it.line_price || 0);
      if (isFinite(v)) s += v;
    }
    return s;
  }

  function getDisplaySubtotal(cart) {
    var base = Number(cart && cart.total_price);
    if (!isFinite(base)) {
      base = sumAllFinalLinePricesCents(cart);
      if (!isFinite(base)) base = 0;
    }
    return Math.max(0, base);
  }

  function renderUpsellFromProducts(products, cartProductIds, limit) {
    var html = [];
    var shown = 0;
    var isCustomer = isCustomerLoggedIn();
    var list = Array.isArray(products) ? products : [];
    for (var i = 0; i < list.length; i++) {
      if (shown >= limit) break;
      var p = list[i] || {};
      var pid = Number(p.id || 0);
      if (!pid || cartProductIds[pid]) continue;
      if (!p.available) continue;

      var variants = Array.isArray(p.variants) ? p.variants : [];
      var variant = null;
      for (var j = 0; j < variants.length; j++) {
        if (variants[j] && variants[j].available) {
          variant = variants[j];
          break;
        }
      }
      if (!variant && variants.length) variant = variants[0];
      if (!variant || !variant.id) continue;

      var href = p.url || '#';
      var title = escHtml(p.title || '');
      var imageSrc = '';
      if (p.featured_image) {
        imageSrc = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url || '';
      }

      html.push('<div class="dd-upsell__card" data-dd-upsell-card data-variant-id="' + escHtml(variant.id) + '">');
      html.push('<a href="' + escHtml(href) + '" class="dd-upsell__image-link">');
      if (imageSrc) {
        html.push(
          '<img src="' +
            escHtml(imageSrc) +
            '" alt="' +
            title +
            '" width="56" height="56" loading="lazy" class="dd-upsell__image">'
        );
      }
      html.push('</a>');
      html.push('<div class="dd-upsell__info">');
      html.push('<a href="' + escHtml(href) + '" class="dd-upsell__title">' + title + '</a>');
      if (isCustomer) html.push('<span class="dd-upsell__price">' + moneyFromCents(variant.price || 0) + '</span>');
      html.push('</div>');
      html.push(
        '<button type="button" class="dd-upsell__add" data-dd-upsell-add data-variant-id="' +
          escHtml(variant.id) +
          '">Add</button>'
      );
      html.push('</div>');
      shown++;
    }
    return html.join('');
  }

  function syncMiniUpsell(cart) {
    var root = getDrawerRoot();
    if (!root) return;
    var host = root.querySelector('[data-dd-upsell-mode="mini"]');
    if (!host) return;
    var grid = host.querySelector('[data-dd-upsell-grid]');
    if (!grid) return;

    var merch = getMerchItems(cart);
    var seed = merch.length ? Number(merch[0].product_id || 0) : Number(host.getAttribute('data-dd-upsell-seed') || 0);
    var limit = Number(host.getAttribute('data-dd-upsell-limit') || 2);
    if (!limit || limit < 1) limit = 2;

    if (!seed) {
      host.style.display = 'none';
      return;
    }
    host.style.display = '';

    var cartProductIds = {};
    for (var i = 0; i < merch.length; i++) {
      var pid = Number(merch[i].product_id || 0);
      if (pid) cartProductIds[pid] = true;
    }

    function paintFrom(list) {
      var html = renderUpsellFromProducts(list, cartProductIds, limit);
      if (html) {
        grid.innerHTML = html;
        _upsellSeedLoaded = seed;
      } else if (_upsellSeedLoaded === seed) {
        host.style.display = 'none';
      }
    }

    if (_upsellCache[seed]) {
      paintFrom(_upsellCache[seed]);
      return;
    }

    if (_upsellInflight[seed]) return;

    var url =
      '/recommendations/products.json?product_id=' +
      encodeURIComponent(seed) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=related';
    _upsellInflight[seed] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Upsell fetch failed (' + r.status + ')');
        return r.json();
      })
      .then(function (payload) {
        var products = Array.isArray(payload && payload.products) ? payload.products : [];
        _upsellCache[seed] = products;
        paintFrom(products);
      })
      .catch(function () {
        /* Keep server-rendered fallback cards if fetch fails */
      })
      .finally(function () {
        delete _upsellInflight[seed];
      });
  }

  function reserveCheckoutNav() {
    var now = Date.now();
    if (now - _checkoutNavTs < 1000) return false;
    _checkoutNavTs = now;
    return true;
  }

  function getDrawerRoot() {
    return document.querySelector('cart-drawer[data-dd-cart-shell="mini"]') || document.querySelector('cart-drawer');
  }

  function getProtectionToastEl() {
    var root = getDrawerRoot();
    return root ? root.querySelector(PROT_TOAST_SEL) : null;
  }

  function isProtectionOff() {
    var root = getDrawerRoot();
    if (!root) return false;
    var widget = root.querySelector(PROT_WIDGET_SEL);
    if (!widget) return false;
    var toggle = widget.querySelector(PROT_TOGGLE_SEL);
    return !!(toggle && !toggle.checked);
  }

  function getProtectionConsentInput(root) {
    var scope = root || getDrawerRoot();
    return scope ? scope.querySelector(PROT_CONSENT_SEL) : null;
  }

  function isProtectionConsentRequired(consent) {
    return !!(consent && isElementInteractable(consent));
  }

  function syncProtectionConsentState(root) {
    var scope = root || getDrawerRoot();
    if (!scope) return;
    var consent = getProtectionConsentInput(scope);
    var isBlocked = isProtectionConsentRequired(consent) && !consent.checked;
    scope.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (button) {
      button.setAttribute('aria-disabled', isBlocked ? 'true' : 'false');
      button.classList.toggle('is-disabled-by-protection', isBlocked);
    });
  }

  function setCheckoutCountdownState(active) {
    var root = getDrawerRoot();
    if (!root) return;
    root.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (btn) {
      btn.classList.toggle('is--loading', !!active);
      btn.setAttribute('aria-busy', active ? 'true' : 'false');
      if (active) btn.setAttribute('data-dd-countdown-lock', 'true');
      else btn.removeAttribute('data-dd-countdown-lock');
    });
  }

  function hideProtectionToast(keepLoading) {
    clearTimeout(_protCountdownTimer);
    _protCountdownTimer = null;
    _protCountdownOn = false;
    if (!keepLoading) setCheckoutCountdownState(false);
    var toast = getProtectionToastEl();
    if (!toast) return;
    toast.classList.remove('is--visible');
    var bar = toast.querySelector('.dd-protection-toast__bar');
    if (bar) bar.style.animation = 'none';
  }

  function goCheckoutNow() {
    if (!reserveCheckoutNav()) {
      hideProtectionToast(false);
      return;
    }
    setCheckoutCountdownState(true);
    window.location.href = CHECKOUT_URL;
  }

  function showProtectionToastThenCheckout() {
    if (_protCountdownOn) return;
    var toast = getProtectionToastEl();
    if (!toast) return;
    _protCountdownOn = true;
    setCheckoutCountdownState(true);
    var bar = toast.querySelector('.dd-protection-toast__bar');
    if (bar) {
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    }
    void toast.offsetWidth;
    toast.classList.add('is--visible');
    _protCountdownTimer = setTimeout(function () {
      hideProtectionToast(true);
      goCheckoutNow();
    }, PROT_COUNTDOWN_MS);
  }

  function resetCheckoutUiState() {
    hideProtectionToast(false);
    setCheckoutCountdownState(false);
    clearCheckoutWarnState();
    syncProtectionConsentState(getDrawerRoot());
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = extractCartFromEventPayload(event);
      if (!cart) return;

      /* Debounce rapid cart updates to prevent UI flickering and redundant renders */
      var now = Date.now();
      if (now - _lastCartUpdateTs < CART_UPDATE_DEBOUNCE_MS) {
        clearTimeout(_cartUpdateDebounceTimer);
        _cartUpdateDebounceTimer = setTimeout(function () {
          _lastCartUpdateTs = Date.now();
          processCartUpdate(cart);
        }, CART_UPDATE_DEBOUNCE_MS);
        return;
      }
      _lastCartUpdateTs = now;
      processCartUpdate(cart);
    });
  }

  function processCartUpdate(cart) {
    /* dd-cart-helpers publishes after every mutate; skipping it blocked threshold + UI sync
       when section HTML replace missed or ran before layout. */
    if (!hasAuthoritativeCartData(cart) && helpers.getLatestCart) {
      var latest = helpers.getLatestCart();
      if (hasAuthoritativeCartData(latest)) cart = latest;
    }
    if (!hasAuthoritativeCartData(cart)) return;
    updateDrawerUI(cart);
  }

  /* On drawer open: if we have a cached cart from a prior mutation, use it
     to re-sync the bar.  On first open, the server-rendered bar is authoritative
     and we skip the update — dd-shipping-protection.js already fetches /cart.js
     on drawer:opened so we avoid a duplicate request here. */
  document.addEventListener('drawer:opened', function () {
    /* Debounce rapid drawer open/close cycles */
    clearTimeout(_drawerOpenDebounceTimer);
    _drawerOpenDebounceTimer = setTimeout(function () {
      var cached = helpers.getLatestCart ? helpers.getLatestCart() : null;
      if (cached && typeof cached.item_count === 'number' && Array.isArray(cached.items)) {
        updateThresholdBar(cached);
        syncMiniUpsell(cached);
      }
      resetCheckoutUiState();
      if (MOBILE_MQ.matches) setFooterExpanded(true);
    }, DRAWER_OPEN_DEBOUNCE_MS);
  });

  document.addEventListener(
    'click',
    function (e) {
      var clickTarget = e && e.target;
      if (clickTarget && clickTarget.nodeType === 3) clickTarget = clickTarget.parentElement;
      if (!clickTarget || typeof clickTarget.closest !== 'function') return;
      var checkoutBtn = clickTarget.closest(CHECKOUT_BTN_SEL);
      if (!checkoutBtn) return;
      if (_protCountdownOn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      var drawerRoot = checkoutBtn.closest('cart-drawer') || getDrawerRoot();
      var consent = getProtectionConsentInput(drawerRoot);
      if (isProtectionConsentRequired(consent) && !consent.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearCheckoutWarnState();
        try {
          consent.focus({ preventScroll: true });
        } catch (ex) {
          consent.focus();
        }
        if (window.ddToast) {
          window.ddToast('Please agree to the shipping protection disclaimer before checkout.', {
            type: 'info'
          });
        }
        return;
      }
      if (window.DDCartState) {
        var giftState = window.DDCartState.get();
        if (
          giftState &&
          giftState.thresholdMet &&
          giftState.qualifies &&
          !giftState.hasColorRingInCart &&
          !giftState.declined &&
          !giftState.pendingClaim &&
          !giftState.busy
        ) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (window.ddToast) {
            window.ddToast('You have an unclaimed free gift \u2014 claim or decline it before checkout.', {
              type: 'warn'
            });
          }
          var scrollHost =
            (drawerRoot && drawerRoot.querySelector('[data-dd-cart-items]')) ||
            document.querySelector('[data-dd-cart-items]');
          if (scrollHost) {
            scrollHost.scrollTo({ top: 0, behavior: 'smooth' });
          }
          setTimeout(function () {
            var card =
              (drawerRoot && drawerRoot.querySelector('.dd-bogos-card')) ||
              document.querySelector('.dd-bogos-card');
            shakeEl(card);
          }, 600);
          return;
        }
      }

      /* ── Unsaved discount / unsaved note guard ──
         Design intent (matches `CHECKOUT_WARN_TTL` reset comment at
         the top of this file): if the shopper has an unapplied
         discount code or an unsaved note, NEVER silently submit to
         /checkout — the savings or message would be lost without
         explanation. `_checkoutWarned` is a no-spam guard for the
         toast (so a frantic double-click doesn't fire the same warn
         twice), NOT a "user has confirmed" acknowledgment. The 6s
         TTL auto-clears the flag so a re-warn is possible after a
         delay; the click delegation below also clears it the
         moment the shopper hits Apply / Save.

         Earlier this branch fell through to the form's default
         submit on the second click within 6s, allowing /checkout
         to proceed without the discount. The cart page mirrored
         the same divergence — both surfaces have been aligned. */
      var unsavedDiscount = hasUnsavedDiscount(checkoutBtn);
      var unsavedNote = hasUnsavedNote(checkoutBtn);
      if (unsavedDiscount || unsavedNote) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!_checkoutWarned) {
          _checkoutWarned = true;
          expandFooterDetails();
          shakeEl(checkoutBtn);
          highlightUnsavedFields(unsavedDiscount, unsavedNote, checkoutBtn);
          if (window.ddToast) {
            var msg = '';
            if (unsavedDiscount && unsavedNote) {
              msg = 'You have an unapplied discount code and an unsaved order note.';
            } else if (unsavedDiscount) {
              msg = 'You have a discount code that hasn\u2019t been applied.';
            } else {
              msg = 'You have an order note that hasn\u2019t been saved.';
            }
            window.ddToast(msg, { type: 'warn' });
          }
          clearTimeout(_checkoutWarnResetTimer);
          _checkoutWarnResetTimer = setTimeout(clearCheckoutWarnState, CHECKOUT_WARN_TTL);
        }
        return;
      }

      /* Fields are clean — clear any stale warn flag from a prior
         warning session the shopper has since resolved without using
         Apply / Save (e.g. they manually cleared the discount input
         so the unsaved check above no longer trips). */
      if (_checkoutWarned) clearCheckoutWarnState();

      if (!isProtectionOff()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showProtectionToastThenCheckout();
    },
    true
  );

  document.addEventListener('click', function (e) {
    var clickTarget = e && e.target;
    if (clickTarget && clickTarget.nodeType === 3) clickTarget = clickTarget.parentElement;
    if (!clickTarget || typeof clickTarget.closest !== 'function') return;
    if (clickTarget.closest('[data-dd-discount-apply]') || clickTarget.closest('[data-dd-note-save]')) {
      clearCheckoutWarnState();
    }
  });

  document.addEventListener('change', function (e) {
    var changeTarget = e && e.target;
    if (changeTarget && changeTarget.nodeType === 3) changeTarget = changeTarget.parentElement;
    if (!changeTarget || typeof changeTarget.closest !== 'function') return;
    var consentInput = changeTarget.closest(PROT_CONSENT_SEL);
    if (consentInput) {
      syncProtectionConsentState(consentInput.closest('cart-drawer') || getDrawerRoot());
      return;
    }
    if (!_protCountdownOn) return;
    var toggle = changeTarget.closest(PROT_TOGGLE_SEL);
    if (toggle && toggle.checked) hideProtectionToast(false);
  });

  document.addEventListener('click', function (e) {
    var clickTarget = e && e.target;
    if (clickTarget && clickTarget.nodeType === 3) clickTarget = clickTarget.parentElement;
    if (!clickTarget || typeof clickTarget.closest !== 'function') return;
    if (!_protCountdownOn) return;
    if (clickTarget.closest('.drawer__close') || clickTarget.closest('#CartDrawer-Overlay')) {
      hideProtectionToast(false);
    }
  });

  window.addEventListener('pageshow', function () {
    resetCheckoutUiState();
  });
  window.addEventListener('focus', resetCheckoutUiState);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetCheckoutUiState();
  });

  /* ── Resolve Regios VIP discount name for automatic discount badge ──
     Uses the official DOPP API event (regios-dopp:api-initialized) per
     https://regiostech.crisp.help/en/article/dopp-api-reference-1gvya0h/
     Non-PDP pages use api.v0.calculateDiscountedPrices (requires product
     data from cart items). PDP pages use api.v0.productPage variant.     ── */
  (function resolveRegiosDiscountName() {
    var _resolved = false;
    var _discountName = null;
    var _inflight = false;
    var _lastApiFailed = false;
    var _retryCount = 0;
    var MAX_RETRIES = 3;
    var RETRY_INTERVAL_MS = 15000;

    var _custId = document.documentElement.getAttribute('data-glass-customer-id') || '0';
    var _storageKey = 'dd_regios_name_' + _custId;

    function persistName(name) {
      if (!name) return;
      try { sessionStorage.setItem(_storageKey, name); } catch (e) {}
    }

    function readCachedName() {
      try { return sessionStorage.getItem(_storageKey) || null; } catch (e) { return null; }
    }

    function markResolved(name) {
      _discountName = name;
      _resolved = true;
      _lastApiFailed = false;
      _retryCount = 0;
      persistName(name);
      applyLabel();
    }

    function applyLabel() {
      if (!_discountName) return;
      var labels = document.querySelectorAll('[data-dd-auto-discount-label]');
      for (var i = 0; i < labels.length; i++) {
        var text = labels[i].textContent || '';
        var amountMatch = text.match(/\((-[^)]+)\)/);
        var amount = amountMatch ? ' (' + amountMatch[1] + ')' : '';
        labels[i].textContent = _discountName + amount;
      }
      if (window.ddDiscountChips && typeof window.ddDiscountChips.render === 'function') {
        window.ddDiscountChips.render();
      }
    }

    function tryFromCartJson(cartData) {
      if (!cartData) return null;
      /* Primary: check `discount_applications` (present in AJAX /cart.js JSON).
         `cart_level_discount_applications` only exists in Liquid, not in AJAX. */
      var apps = cartData.discount_applications || cartData.cart_level_discount_applications || [];
      for (var i = 0; i < apps.length; i++) {
        var app = apps[i];
        if (app && (app.type === 'automatic' || app.type === 'script' || app.type === 'manual') && app.title) {
          return app.title;
        }
      }
      return null;
    }

    function getFirstRealItem(cartData) {
      if (!cartData || !Array.isArray(cartData.items)) return null;
      for (var i = 0; i < cartData.items.length; i++) {
        if (!isProtectionLikeItem(cartData.items[i])) return cartData.items[i];
      }
      return null;
    }

    function fireRegiosCall(api, item) {
      /* item may be null on a product page — the productPage API works without it. */
      var isPDP = !!(api.productPage && typeof api.productPage.calculateDiscountedPrices === 'function');
      var calcFn, calcArgs;

      if (isPDP) {
        calcFn = api.productPage.calculateDiscountedPrices.bind(api.productPage);
        calcArgs = item
          ? { variantId: Number(item.variant_id || item.id), quantity: 1 }
          : { quantity: 1 };
      } else if (item && typeof api.calculateDiscountedPrices === 'function') {
        calcFn = api.calculateDiscountedPrices.bind(api);
        calcArgs = {
          productId: Number(item.product_id),
          variantId: Number(item.variant_id || item.id),
          regularPriceInCents: Number(item.original_price || item.price)
        };
      } else {
        _inflight = false;
        return;
      }

      calcFn(calcArgs)
        .then(function (result) {
          /* Regios DOPP API: { badge: { html, css }, description: { html, css }, salePrice, regularPrice }
             Prefer description (= [discount_message] / tier name) over badge (= "[X]% OFF").

             Bare "<X>% OFF" responses are rejected: when the customer has
             no Regios tier match (e.g. the only saving on the cart comes
             from a code like WELCOME-XXXX), the API typically returns
             "0% OFF" — adopting it would overwrite the Liquid-rendered
             percentage with a misleading 0%. The cached-result path
             already filters this; mirror it here for fresh calls so the
             two code paths agree. */
          var raw = result && (
            (result.description && result.description.html) ||
            (result.badge && result.badge.html)
          );
          if (raw) {
            var tmp = document.createElement('div');
            tmp.innerHTML = raw;
            var name = (tmp.textContent || tmp.innerText || '').trim();
            if (name && !/^\d+(\.\d+)?% OFF$/i.test(name)) {
              markResolved(name);
            } else {
              _lastApiFailed = true;
            }
          } else {
            /* API returned but no usable name - may need retry */
            _lastApiFailed = true;
          }
        })
        .catch(function (err) {
          console.warn('[DD Regios] DOPP API error:', err);
          _lastApiFailed = true;
        })
        .finally(function () { _inflight = false; });
    }

    function callRegiosApi(api, forceRetry) {
      if (_resolved) return;
      if (_inflight && !forceRetry) return;

      var cartData = helpers.getLatestCart && helpers.getLatestCart();
      var isPDP = !!(api.productPage && typeof api.productPage.calculateDiscountedPrices === 'function');
      var item = getFirstRealItem(cartData);

      if (item || isPDP) {
        /* Have what we need — fire immediately */
        _inflight = true;
        fireRegiosCall(api, item);
      } else {
        _inflight = true;
        var regiosCartPromise;
        if (window.ddCartHelpers && typeof window.ddCartHelpers.ensureFreshCart === 'function') {
          regiosCartPromise = window.ddCartHelpers.ensureFreshCart();
        } else {
          regiosCartPromise = fetch('/cart.js').then(function (r) { return r.json(); });
        }
        regiosCartPromise
          .then(function (fresh) {
            var freshItem = getFirstRealItem(fresh);
            fireRegiosCall(api, freshItem);
          })
          .catch(function (err) {
            console.warn('[DD Regios] /cart.js fetch error:', err);
            _inflight = false;
            _lastApiFailed = true;
          });
      }
    }

    function getShopifyDiscountTitle() {
      /* Returns the Shopify-level discount title as a temporary placeholder.
         This is NOT the authoritative Regios tier name — the DOPP API is.
         Used only to show something while the async DOPP call is in flight. */
      var el = document.querySelector('[data-dd-resolved-discount-name]');
      if (el) {
        var name = (el.getAttribute('data-dd-resolved-discount-name') || '').trim();
        if (name && name !== 'Automatic account discount') return name;
      }
      var cartData = helpers.getLatestCart && helpers.getLatestCart();
      return tryFromCartJson(cartData);
    }

    function applyPlaceholder() {
      /* Show the Shopify title immediately while DOPP call is in flight.
         Overwrites only labels that still show the generic fallback text. */
      var placeholder = getShopifyDiscountTitle();
      if (!placeholder) return;
      var labels = document.querySelectorAll('[data-dd-auto-discount-label]');
      for (var i = 0; i < labels.length; i++) {
        var text = labels[i].textContent || '';
        if (text.indexOf('Automatic account discount') !== -1) {
          var amountMatch = text.match(/\((-[^)]+)\)/);
          var amount = amountMatch ? ' (' + amountMatch[1] + ')' : '';
          labels[i].textContent = placeholder + amount;
        }
      }
    }

    function tryResolveSync() {
      if (_resolved) return;

      /* sessionStorage holds a confirmed DOPP result from a prior call —
         trust it and skip the API call.
         Reject raw Shopify percentage strings (e.g. "20% OFF") that may have
         been cached by an older version of this code before the DOPP fix. */
      var cached = readCachedName();
      if (cached && !/^\d+(\.\d+)?% OFF$/i.test(cached.trim())) {
        markResolved(cached);
      }
    }

    function onApiReady(api) {
      if (_resolved) { applyLabel(); return; }
      tryResolveSync();
      if (_resolved) return;
      applyPlaceholder();
      callRegiosApi(api);
    }

    function init() {
      tryResolveSync();
      if (_resolved) return;

      if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
        onApiReady(window.RegiosDOPP.api.v0);
      } else {
        applyPlaceholder();
        window.addEventListener('regios-dopp:api-initialized', function (e) {
          var api = e.detail && e.detail.api;
          if (api) onApiReady(api);
        });
      }
    }

    /* Retry on visibility change if API failed */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && !_resolved && _lastApiFailed) {
        _lastApiFailed = false;
        if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
          callRegiosApi(window.RegiosDOPP.api.v0, true);
        }
      }
    });

    /* Periodic retry if not resolved */
    setInterval(function () {
      if (_resolved || _inflight) return;
      if (_retryCount >= MAX_RETRIES) return;
      _retryCount++;
      if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
        callRegiosApi(window.RegiosDOPP.api.v0, true);
      }
    }, RETRY_INTERVAL_MS);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('drawer:opened', function () {
      if (_resolved) { applyLabel(); return; }
      tryResolveSync();
      if (_resolved) return;
      applyPlaceholder();
      if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
        callRegiosApi(window.RegiosDOPP.api.v0);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (_resolved) { applyLabel(); return; }
        tryResolveSync();
        if (_resolved) return;
        applyPlaceholder();
        if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
          callRegiosApi(window.RegiosDOPP.api.v0);
        }
      });
    }
  })();

  /* KTip xsell fallback bootstrap:
     If xsell markup is injected by section swaps after initial load,
     inline snippet scripts may not execute. This keeps dropdown/add
     interactive in the mini-cart regardless of render timing. */
  (function initKtipXsellFallback() {
    if (window._ktipXsellInit || window._ddKtipXsellFallbackInit) return;
    window._ddKtipXsellFallbackInit = true;

    function normTarget(e) {
      var t = e && e.target;
      if (t && t.nodeType === 3) t = t.parentElement;
      return t && typeof t.closest === 'function' ? t : null;
    }

    function parseVariants(xsell) {
      var raw = xsell && xsell.getAttribute('data-variants');
      if (!raw) return [];
      var entries = raw.split(';');
      var out = [];
      for (var i = 0; i < entries.length; i++) {
        var p = entries[i].split('|');
        if (p.length < 4) continue;
        out.push({
          id: String(p[0] || ''),
          length: String(p[1] || ''),
          price: parseInt(p[2] || '0', 10) || 0,
          available: p[3] === 'true',
          image: String(p[4] || ''),
          compareAt: parseInt(p[5] || '0', 10) || 0
        });
      }
      return out;
    }

    function normalizeLength(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/inches|inch|in/g, '')
        .replace(/["']/g, '')
        .replace(/\s+/g, '');
    }

    function formatMoney(cents) {
      var val = parseInt(cents || 0, 10) / 100;
      return '$' + val.toFixed(2);
    }

    function pickVariantByLength(variants, length) {
      var i;
      var firstExact = null;
      for (i = 0; i < variants.length; i++) {
        if (variants[i].length !== length) continue;
        if (!firstExact) firstExact = variants[i];
        if (variants[i].available) return variants[i];
      }
      if (firstExact) return firstExact;

      var targetNorm = normalizeLength(length);
      var firstNorm = null;
      for (i = 0; i < variants.length; i++) {
        if (normalizeLength(variants[i].length) !== targetNorm) continue;
        if (!firstNorm) firstNorm = variants[i];
        if (variants[i].available) return variants[i];
      }
      return firstNorm;
    }

    function updateForLength(xsell, length) {
      if (!xsell) return;
      var variants = parseVariants(xsell);
      if (!variants.length) return;
      var match = pickVariantByLength(variants, length);
      if (!match) return;

      var addBtn = xsell.querySelector('[data-ktip-add]');
      var labelEl = xsell.querySelector('[data-ktip-dd-label]');
      var menu = xsell.querySelector('[data-ktip-dd-menu]');
      var priceEl = xsell.querySelector('[data-ktip-price]');
      var compareEl = xsell.querySelector('[data-ktip-compare-price]');
      var thumbImg = xsell.querySelector('.ktip-xsell__thumb img');

      if (addBtn) {
        addBtn.setAttribute('data-variant-id', match.id);
        addBtn.setAttribute('data-ktip-length', match.length || length || '');
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add' : 'Sold Out';
      }
      if (labelEl) labelEl.textContent = match.length || length;

      if (priceEl) {
        priceEl.textContent = formatMoney(match.price);
        priceEl.classList.toggle('ktip-xsell__price--sale', match.compareAt > match.price);
      }
      if (compareEl) {
        if (match.compareAt > match.price) {
          compareEl.textContent = formatMoney(match.compareAt);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Keep thumb deterministic on fallback path:
      // use the selected variant image from data-variants (Liquid already
      // prioritizes custom.variant_image first image when building that list).
      if (thumbImg && match.image) {
        thumbImg.src = match.image;
      }

      if (menu) {
        var items = menu.querySelectorAll('[data-ktip-dd-item]');
        for (var i = 0; i < items.length; i++) {
          var selected = items[i].getAttribute('data-value') === (match.length || length);
          items[i].classList.toggle('is--selected', selected);
          if (selected) items[i].setAttribute('aria-selected', 'true');
          else items[i].removeAttribute('aria-selected');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var target = normTarget(e);
      if (!target) return;

      var trigger = target.closest('[data-ktip-dd-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var dd = trigger.closest('[data-ktip-dd]');
        if (!dd) return;
        var wasOpen = dd.classList.contains('is--open');
        var openDds = document.querySelectorAll('[data-ktip-dd].is--open');
        for (var i = 0; i < openDds.length; i++) openDds[i].classList.remove('is--open');
        if (!wasOpen) dd.classList.add('is--open');
        return;
      }

      var item = target.closest('[data-ktip-dd-item]');
      if (item && !item.classList.contains('is--soldout')) {
        e.preventDefault();
        var xsell = item.closest('[data-ktip-xsell]');
        if (xsell) updateForLength(xsell, item.getAttribute('data-value') || '');
        var ddWrap = item.closest('[data-ktip-dd]');
        if (ddWrap) ddWrap.classList.remove('is--open');
        return;
      }

      var addBtn = target.closest('[data-ktip-add]');
      if (addBtn) {
        if (addBtn.disabled) return;
        e.preventDefault();
        var xs = addBtn.closest('[data-ktip-xsell]');
        var variantId = parseInt(addBtn.getAttribute('data-variant-id') || '0', 10);
        if (!xs || !variantId) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        var ktipItem = { id: variantId, quantity: 1, properties: { _ktip_source: 'superweft' } };
        var addPromise;
        if (window.ddCartHelpers && typeof window.ddCartHelpers.cartMutate === 'function') {
          var coalesceKey = typeof window.ddCartHelpers.makeCoalesceKey === 'function'
            ? window.ddCartHelpers.makeCoalesceKey('ktip-add', variantId)
            : 'ktip-add:' + String(variantId);
          addPromise = window.ddCartHelpers.cartMutate(
            '/cart/add.js',
            { items: [ktipItem] },
            { action: 'ktip-add', coalesceKey: coalesceKey }
          );
        } else {
          addPromise = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [ktipItem], sections: 'cart-drawer,cart-icon-bubble' })
          }).then(function (r) { if (!r.ok) throw new Error('Add failed (' + r.status + ')'); return r.json(); });
        }

        addPromise
          .then(function () {
            xs.classList.add('is--added');
            addBtn.textContent = 'Added!';
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Add';
            if (window.ddToast) window.ddToast('Couldn’t add item — please try again', { type: 'error' });
          });
        return;
      }

      var insideDd = target.closest('[data-ktip-dd]');
      if (!insideDd) {
        var allOpen = document.querySelectorAll('[data-ktip-dd].is--open');
        for (var j = 0; j < allOpen.length; j++) allOpen[j].classList.remove('is--open');
      }
    });
  })();
})();
